import { render, staticRenderFns } from "./select_left.vue?vue&type=template&id=4c2461d2&scoped=true&"
import script from "./select_left.vue?vue&type=script&lang=js&"
export * from "./select_left.vue?vue&type=script&lang=js&"
import style0 from "./select_left.vue?vue&type=style&index=0&id=4c2461d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2461d2",
  null
  
)

export default component.exports